import { ArrayType, convertNumber, NumberType, ObjectType, StringType, } from '@hb/map-convert';
import { convertPoint } from '../../utils/transform';
function convertContourType(v) {
    return convertNumber(v) >= 1 ? 'all' : 'base';
}
/**
 * 入参转换
 */
export var queryType = {
    keywords: StringType(),
    subDistrict: StringType('subdistrict'),
    contourType: StringType('extensions', convertContourType),
    page: StringType('page'),
    offset: StringType('offset'),
};
var cities = {
    name: StringType(),
    num: NumberType(),
    citycode: StringType('cityCode'),
    adcode: StringType('adCode'),
};
export var suggestionType = {
    keywords: ArrayType(StringType(), 'keys'),
    key_word: StringType('keywords'),
    cities: ArrayType(ObjectType(cities)),
};
export var districtType = {
    citycode: StringType('cityCode'),
    adcode: StringType('adCode'),
    name: StringType(),
    polyline: StringType(),
    center: StringType('centerLocation', convertPoint),
    level: StringType(),
};
/**
 * 返回值转换
 */
// export const dataType: ConvertType = {
//   suggestion: ObjectType(suggestionType),
//   districts: ObjectType(districtType),
// };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2FtYXAvZGlzdHJpY3RTZWFyY2hCeVNlcnZlci9jb252ZXJ0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxTQUFTLEVBQ1QsYUFBYSxFQUNiLFVBQVUsRUFDVixVQUFVLEVBQ1YsVUFBVSxHQUNYLE1BQU0saUJBQWlCLENBQUM7QUFHekIsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRXJELFNBQVMsa0JBQWtCLENBQUMsQ0FBUztJQUNuQyxPQUFPLGFBQWEsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDO0FBQ2hELENBQUM7QUFFRDs7R0FFRztBQUNILE1BQU0sQ0FBQyxJQUFNLFNBQVMsR0FBZ0I7SUFDcEMsUUFBUSxFQUFFLFVBQVUsRUFBRTtJQUN0QixXQUFXLEVBQUUsVUFBVSxDQUFDLGFBQWEsQ0FBQztJQUN0QyxXQUFXLEVBQUUsVUFBVSxDQUFDLFlBQVksRUFBRSxrQkFBa0IsQ0FBQztJQUN6RCxJQUFJLEVBQUUsVUFBVSxDQUFDLE1BQU0sQ0FBQztJQUN4QixNQUFNLEVBQUUsVUFBVSxDQUFDLFFBQVEsQ0FBQztDQUM3QixDQUFDO0FBRUYsSUFBTSxNQUFNLEdBQWdCO0lBQzFCLElBQUksRUFBRSxVQUFVLEVBQUU7SUFDbEIsR0FBRyxFQUFFLFVBQVUsRUFBRTtJQUNqQixRQUFRLEVBQUUsVUFBVSxDQUFDLFVBQVUsQ0FBQztJQUNoQyxNQUFNLEVBQUUsVUFBVSxDQUFDLFFBQVEsQ0FBQztDQUM3QixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sY0FBYyxHQUFnQjtJQUN6QyxRQUFRLEVBQUUsU0FBUyxDQUFDLFVBQVUsRUFBRSxFQUFFLE1BQU0sQ0FBQztJQUN6QyxRQUFRLEVBQUUsVUFBVSxDQUFDLFVBQVUsQ0FBQztJQUNoQyxNQUFNLEVBQUUsU0FBUyxDQUFDLFVBQVUsQ0FBQyxNQUFNLENBQUMsQ0FBQztDQUN0QyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sWUFBWSxHQUFnQjtJQUN2QyxRQUFRLEVBQUUsVUFBVSxDQUFDLFVBQVUsQ0FBQztJQUNoQyxNQUFNLEVBQUUsVUFBVSxDQUFDLFFBQVEsQ0FBQztJQUM1QixJQUFJLEVBQUUsVUFBVSxFQUFFO0lBQ2xCLFFBQVEsRUFBRSxVQUFVLEVBQUU7SUFDdEIsTUFBTSxFQUFFLFVBQVUsQ0FBQyxnQkFBZ0IsRUFBRSxZQUFZLENBQUM7SUFDbEQsS0FBSyxFQUFFLFVBQVUsRUFBRTtDQUNwQixDQUFDO0FBRUY7O0dBRUc7QUFDSCx5Q0FBeUM7QUFDekMsNENBQTRDO0FBQzVDLHlDQUF5QztBQUN6QyxLQUFLIn0=